module.exports = __webpack_public_path__ + "media/images/vp/icon.leftarrow2.black-cc47568c630455fc3ee3c4cfe65a3127.svg";